module.exports = __webpack_public_path__ + "static/media/TO.81f4e8cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TO.svg
// module id = 377
// module chunks = 0